import { LogOut, type LucideIcon } from "lucide-react"
import { SidebarGroup, SidebarMenu, SidebarMenuButton } from "@/components/ui/sidebar"
import { Link } from "react-router-dom"
import { useAuth } from "@/modules/auth/store"
import useFlags from "@/hooks/use-flags"

export interface NavFooterItem {
  title: string
  url: string
  icon: LucideIcon
}

interface NavFooterProps {
  items: NavFooterItem[]
}

export function NavFooter({ items }: NavFooterProps) {
  const { logOut } = useAuth()
  const { logoutButton: canShowLogoutButton } = useFlags()

  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item) => (
          <Link key={item.url} to={item.url}>
            <SidebarMenuButton
              className="gap-4 [&>svg]:m-[-2px] [&>svg]:size-5"
              asChild
              tooltip={item.title}
            >
              <div className="my-2 flex w-full">
                <item.icon strokeWidth={1.6} />
                <p className="mt-1 text-xs font-medium">{item.title}</p>
              </div>
            </SidebarMenuButton>
          </Link>
        ))}

        {canShowLogoutButton && (
          <SidebarMenuButton
            className="gap-4 [&>svg]:m-[-2px] [&>svg]:size-5"
            tooltip="Salir"
            asChild
          >
            <div className="my-2 flex w-full cursor-pointer" onClick={logOut}>
              <LogOut strokeWidth={1.6} />
              <p className="mt-1 text-xs font-medium">Salir</p>
            </div>
          </SidebarMenuButton>
        )}
      </SidebarMenu>
    </SidebarGroup>
  )
}
